/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccessDeniedErrorResponse,
  AssociatePropertyOwnerRequest,
  BadRequestErrorResponse,
  ConflictErrorResponse,
  CreateOwnerRequest,
  GetApiPropertyOwnersList200,
  GetApiPropertyOwnersListParams,
  NotFoundErrorResponse,
  OwnerApiResource,
  UnauthorizedErrorResponse
} from '.././models';

import { customFetch } from '../../custom-fetch';

export type getApiPropertyOwnersListResponse200 = {
  data: GetApiPropertyOwnersList200
  status: 200
}

export type getApiPropertyOwnersListResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type getApiPropertyOwnersListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiPropertyOwnersListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getApiPropertyOwnersListResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiPropertyOwnersListResponseSuccess = (getApiPropertyOwnersListResponse200) & {
  headers: Headers;
};
export type getApiPropertyOwnersListResponseError = (getApiPropertyOwnersListResponse400 | getApiPropertyOwnersListResponse401 | getApiPropertyOwnersListResponse403 | getApiPropertyOwnersListResponse404) & {
  headers: Headers;
};

export type getApiPropertyOwnersListResponse = (getApiPropertyOwnersListResponseSuccess | getApiPropertyOwnersListResponseError)

export const getGetApiPropertyOwnersListUrl = (propertyId: string,
    params?: GetApiPropertyOwnersListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/properties/${propertyId}/owners?${stringifiedParams}` : `/api/properties/${propertyId}/owners`
}

export const getApiPropertyOwnersList = async (propertyId: string,
    params?: GetApiPropertyOwnersListParams, options?: RequestInit): Promise<getApiPropertyOwnersListResponse> => {
  
  return customFetch<getApiPropertyOwnersListResponse>(getGetApiPropertyOwnersListUrl(propertyId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type postApiPropertyOwnerAssociateResponse204 = {
  data: void
  status: 204
}

export type postApiPropertyOwnerAssociateResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type postApiPropertyOwnerAssociateResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type postApiPropertyOwnerAssociateResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type postApiPropertyOwnerAssociateResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}

export type postApiPropertyOwnerAssociateResponse409 = {
  data: ConflictErrorResponse
  status: 409
}
    
export type postApiPropertyOwnerAssociateResponseSuccess = (postApiPropertyOwnerAssociateResponse204) & {
  headers: Headers;
};
export type postApiPropertyOwnerAssociateResponseError = (postApiPropertyOwnerAssociateResponse400 | postApiPropertyOwnerAssociateResponse401 | postApiPropertyOwnerAssociateResponse403 | postApiPropertyOwnerAssociateResponse404 | postApiPropertyOwnerAssociateResponse409) & {
  headers: Headers;
};

export type postApiPropertyOwnerAssociateResponse = (postApiPropertyOwnerAssociateResponseSuccess | postApiPropertyOwnerAssociateResponseError)

export const getPostApiPropertyOwnerAssociateUrl = (propertyId: number,) => {


  

  return `/api/properties/${propertyId}/owners`
}

export const postApiPropertyOwnerAssociate = async (propertyId: number,
    associatePropertyOwnerRequest: AssociatePropertyOwnerRequest, options?: RequestInit): Promise<postApiPropertyOwnerAssociateResponse> => {
  
  return customFetch<postApiPropertyOwnerAssociateResponse>(getPostApiPropertyOwnerAssociateUrl(propertyId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      associatePropertyOwnerRequest,)
  }
);}


export type postApiPropertyOwnerCreateAndAssociateResponse201 = {
  data: OwnerApiResource
  status: 201
}

export type postApiPropertyOwnerCreateAndAssociateResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type postApiPropertyOwnerCreateAndAssociateResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type postApiPropertyOwnerCreateAndAssociateResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type postApiPropertyOwnerCreateAndAssociateResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}

export type postApiPropertyOwnerCreateAndAssociateResponse409 = {
  data: ConflictErrorResponse
  status: 409
}
    
export type postApiPropertyOwnerCreateAndAssociateResponseSuccess = (postApiPropertyOwnerCreateAndAssociateResponse201) & {
  headers: Headers;
};
export type postApiPropertyOwnerCreateAndAssociateResponseError = (postApiPropertyOwnerCreateAndAssociateResponse400 | postApiPropertyOwnerCreateAndAssociateResponse401 | postApiPropertyOwnerCreateAndAssociateResponse403 | postApiPropertyOwnerCreateAndAssociateResponse404 | postApiPropertyOwnerCreateAndAssociateResponse409) & {
  headers: Headers;
};

export type postApiPropertyOwnerCreateAndAssociateResponse = (postApiPropertyOwnerCreateAndAssociateResponseSuccess | postApiPropertyOwnerCreateAndAssociateResponseError)

export const getPostApiPropertyOwnerCreateAndAssociateUrl = (propertyId: string,) => {


  

  return `/api/properties/${propertyId}/owners/create`
}

export const postApiPropertyOwnerCreateAndAssociate = async (propertyId: string,
    createOwnerRequest: CreateOwnerRequest, options?: RequestInit): Promise<postApiPropertyOwnerCreateAndAssociateResponse> => {
  
  return customFetch<postApiPropertyOwnerCreateAndAssociateResponse>(getPostApiPropertyOwnerCreateAndAssociateUrl(propertyId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createOwnerRequest,)
  }
);}


export type deleteApiPropertyOwnerDisconnectResponse204 = {
  data: void
  status: 204
}

export type deleteApiPropertyOwnerDisconnectResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type deleteApiPropertyOwnerDisconnectResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type deleteApiPropertyOwnerDisconnectResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type deleteApiPropertyOwnerDisconnectResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type deleteApiPropertyOwnerDisconnectResponseSuccess = (deleteApiPropertyOwnerDisconnectResponse204) & {
  headers: Headers;
};
export type deleteApiPropertyOwnerDisconnectResponseError = (deleteApiPropertyOwnerDisconnectResponse400 | deleteApiPropertyOwnerDisconnectResponse401 | deleteApiPropertyOwnerDisconnectResponse403 | deleteApiPropertyOwnerDisconnectResponse404) & {
  headers: Headers;
};

export type deleteApiPropertyOwnerDisconnectResponse = (deleteApiPropertyOwnerDisconnectResponseSuccess | deleteApiPropertyOwnerDisconnectResponseError)

export const getDeleteApiPropertyOwnerDisconnectUrl = (propertyId: number,
    ownerId: number,) => {


  

  return `/api/properties/${propertyId}/owners/${ownerId}`
}

export const deleteApiPropertyOwnerDisconnect = async (propertyId: number,
    ownerId: number, options?: RequestInit): Promise<deleteApiPropertyOwnerDisconnectResponse> => {
  
  return customFetch<deleteApiPropertyOwnerDisconnectResponse>(getDeleteApiPropertyOwnerDisconnectUrl(propertyId,ownerId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}


